import styled, { css, keyframes } from "styled-components";
import { shade800, shade850 } from "../../styles/tokens";

// TEXT

// STYLES
const skeletonShimmer = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

export const Skeleton = styled.div<{
  $height: string;
  $width: string;
  $display?: string;
  $ellipse?: boolean;
}>`
  line-height: 100%;
  width: ${({ $width }) => $width};
  min-height: ${({ $height }) => $height};
  display: ${({ $display }) => $display || "inline-block"};
  border-radius: ${({ $ellipse }) => ($ellipse ? "50%" : "none")};
  background: linear-gradient(
    100deg,
    ${shade850} 20%,
    ${shade800} 50%,
    ${shade850} 60%
  );
  animation: ${skeletonShimmer} 3s linear infinite forwards;
  background-size: 200% 100%; /* Makes the shimmer effect cover the entire element */
`;

export const skeletonizeStyles = css`
  box-shadow: none;
  position: relative;
  pointer-events: none;
  background: #00000000;
  border-color: #00000000;
  color: transparent;
  z-index: 0;

  &::after {
    inset: -1px;
    z-index: 1;
    content: "";
    position: absolute;
    border-radius: inherit;

    background: linear-gradient(
      100deg,
      ${shade850} 20%,
      ${shade800} 50%,
      ${shade850} 60%
    );
    animation: ${skeletonShimmer} 3s linear infinite forwards;
    background-size: 200% 100%; /* Makes the shimmer effect cover the entire element */
  }
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
